import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';

import '../src/index.css';
import Documentation from "./pages/Documentation";
import Integration from "./pages/Integration";
import Examples from "./pages/Examples";
import Contact from "./pages/Contact";
import SecurityPage from "./pages/SecurityPage";
import QuickStart from "./pages/QuickStart";
import SdkPage from "./pages/SdkPage";
import Authentication from "./pages/Authentication";
import PaymentFlow from "./pages/PaymentFlow";
import ErrorCodes from "./pages/ErrorCodes";
import Status from "./pages/Status";
import Changelog from "./pages/Changelog";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import Compliance from "./pages/Compliance";
import FAQ from "./pages/FAQ";
import HelpCenter from "./pages/HelpCenter";
import TechnicalSupport from "./pages/TechnicalSupport";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Careers from "./pages/Careers";
import ApiReference from "./pages/ApiReference";
import AssistantPage from "./pages/AssistantPage";
import Plugins from "./pages/Plugins";
import CookieBanner from "./components/shared/CookieBanner";
import ChatWidget from "./components/assistant/ChatWidget";

function KeyboardShortcuts() {
    const navigate = useNavigate();
    useEffect(() => {
        const onKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'A') {
                e.preventDefault();
                navigate('/assistant');
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [navigate]);
    return null;
}

function AppContent() {
    const location = useLocation();
    const isAssistantPage = location.pathname === '/assistant';

    return (
        <>
            <KeyboardShortcuts />
            <div className="App min-h-screen bg-gray-50 transition-colors duration-200 dark:bg-slate-950 dark:text-slate-100">
                <Navbar />
                <main>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/documentation" element={<Documentation />} />
                            <Route path="/integration" element={<Integration />} />
                            <Route path="/examples" element={<Examples />} />
                            <Route path="/security" element={<SecurityPage />} />
                            <Route path="/quickstart" element={<QuickStart />} />
                            <Route path="/sdk" element={<SdkPage />} />
                            <Route path="/authentication" element={<Authentication />} />
                            <Route path="/payment-flow" element={<PaymentFlow />} />
                            <Route path="/error-codes" element={<ErrorCodes />} />
                            <Route path="/status" element={<Status />} />
                            <Route path="/changelog" element={<Changelog />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/cookies" element={<Cookies />} />
                            <Route path="/compliance" element={<Compliance />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/help-center" element={<HelpCenter />} />
                            <Route path="/technical-support" element={<TechnicalSupport />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<Blog />} />
                            <Route path="/careers" element={<Careers />} />
                            <Route path="/api-reference" element={<ApiReference />} />
                            <Route path="/assistant" element={<AssistantPage />} />
                            <Route path="/plugins" element={<Plugins />} />
                        </Routes>
                    </main>
                    {!isAssistantPage && <Footer />}
                <CookieBanner />
                {!isAssistantPage && <ChatWidget />}
            </div>
        </>
    );
}

function App() {
    return (
        <HelmetProvider>
            <Router>
                <AppContent />
            </Router>
        </HelmetProvider>
    );
}

export default App;